export enum INSTANCE_SETTINGS {
    /**
     * @value Advanced settings
     */
    ADVANCED_SETTINGS = 'ADMIN.INSTANCE.ADVANCED_SETTINGS',
    /**
     * @value Default website
     */
    DEFAULT_INSTANCE = 'ADMIN_INSTANCE_DEFAULT_INSTANCE',
    /**
     * @value Default language
     */
    DEFAULT_LANGUAGE = 'ADMIN_INSTANCE_DEFAULT_LANG',
    /**
     * @value An unexpected error occurred while loading your site. Please contact your administrator.
     */
    ERROR_WHILE_LOADING_INSTANCE = 'LOADING.ERROR.INSTANCE.GET',
    /**
     * @value Global settings
     */
    GLOBAL_SETTINGS = 'ADMIN.ADVANCED_SETTINGS.DEFAULT_CATEGORY',
    /**
     * @value LumApps supports GA3 (UA-) or GA4 (G-) tags.
     */
    GOOGLE_ANALYTICS_HELPER = 'INSTANCE_SETTINGS.GOOGLE_ANALYTICS_HELPER',
    /**
     * @value Google Tag Manager
     */
    GOOGLE_TAG_MANAGER = 'ADMIN_INSTANCE_GOOGLE_TAG_MANAGER',
    /**
     * @value Configuration
     */
    INSTANCE_CONFIGURATION = 'ADMIN_INSTANCE_CONFIGURATION',
    /**
     * @value Override
     */
    INSTANCE_OVERRIDE = 'ADMIN_INSTANCE_OVERRIDE',
    /**
     * @value Name in URL already used
     */
    INSTANCE_SLUG_EXIST = 'SERVER_ERROR_ADMIN_INSTANCE_SLUG_EXIST',
    /**
     * @value Theme
     */
    INSTANCE_THEME = 'ADMIN_INSTANCE_THEME',
    /**
     * @value Google Analytics tracking ID is invalid
     */
    INVALID_GOOGLE_ANALYTICS = 'SERVER_ERROR_INVALID_GOOGLE_ANALYTICS',
    /**
     * @value Google Tag Manager tracking ID is invalid
     */
    INVALID_GOOGLE_TAG_MANAGER = 'SERVER_ERROR_INVALID_GOOGLE_TAG_MANAGER',
    /**
     * @value Select groups to push in favorites
     */
    IN_FAVORITE_FEEDS = 'ADMIN.INSTANCE.IN_FAVORITE_FEEDS',
    /**
     * @value Deletable from favorites
     */
    IS_DELETABLE_FROM_FAVORITE = 'ADMIN.INSTANCE.IS_DELETABLE_FROM_FAVORITE',
    /**
     * @value Parent site
     */
    PARENT_SITE = 'ADMIN_INSTANCE_PARENT',
    /**
     * @value Public content allowed
     */
    PUBLIC_CONTENT = 'ADMIN_INSTANCE_PUBLIC_CONTENT',
    /**
     * @value Restrict to
     */
    RESTRICT_TO = 'ADMIN.INSTANCE.RESTRICT_TO',
    /**
     * @value Child sites can search through other child sites
     */
    SEARCH_CHILDREN_LIST_CHILDREN = 'ADMIN_INSTANCE_SEARCH_CHILDREN_LIST_CHILDREN',
    /**
     * @value Child sites can search through their parent site
     */
    SEARCH_CHILDREN_LIST_PARENT = 'ADMIN_INSTANCE_SEARCH_CHILDREN_LIST_PARENT',
    /**
     * @value Parent site can search child sites
     */
    SEARCH_PARENT_LIST_CHILDREN = 'ADMIN_INSTANCE_SEARCH_PARENT_LIST_CHILDREN',
    /**
     * @value Site metadata
     */
    SITE_METADATA = 'ADMIN_INSTANCE_METADATA',
    /**
     * @value Site name
     */
    SITE_NAME = 'ANALYTICS.SITES.TABLE_HEAD_NAME',
}
